import { createFileRoute, Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { PageHeader } from '@/components/layout/page-header'
import { Button } from '@/components/ui/button'
import { requireActualVsBudgetPortfolioAccess } from '@/features/actual-vs-budget-production/access'
import { PortfolioActualVsBudgetTable } from '@/components/custom/actual-vs-budget-production/portfolio-table'

export const Route = createFileRoute('/_authenticated/actual-vs-budget')({
  beforeLoad: requireActualVsBudgetPortfolioAccess,
  component: ActualVsBudgetPage,
})

function ActualVsBudgetPage() {
  return (
    <div className="flex min-h-0 min-w-0 flex-1 flex-col gap-6 overflow-y-auto pb-8 pr-4 md:pr-8">
      <PageHeader title="Portfolio Actual vs Budget" useSeparator={false}>
        <Button asChild variant="outline">
          <Link to="/companies">
            <ArrowLeft className="size-4" aria-hidden="true" />
            Back to Companies
          </Link>
        </Button>
      </PageHeader>
      <PortfolioActualVsBudgetTable />
    </div>
  )
}
